

export type PullReplicationMode =
    "None"
    | "HubToSink"
    | "SinkToHub"
    | "HubToSink,SinkToHub";